module.exports = __webpack_public_path__ + "img/axe-crossed.fac8aae9.svg";